// extracted by mini-css-extract-plugin
module.exports = {"container":"GalleryCard_container__2Dm4A","card__title__container":"GalleryCard_card__title__container__3oIpF","card__inner__container":"GalleryCard_card__inner__container__1wgs8"};